import { SeoListName } from 'shared/analytics/types'

export const seoListNameDynamic = (listName: SeoListName, name: string) => {
  return listName.replace('{name}', name) as SeoListName
}
